/**
 * import react
 */
import React from 'react';

/**
 * import material-ui
 */
import TabelRow from '@material-ui/core/TableRow';
import TabelCell from '@material-ui/core/TableCell';

const SlotTableHeadRow = () => {
  return (
    <TabelRow>
      <TabelCell style={{ padding: 8 }}>Select</TabelCell>
      <TabelCell style={{ textAlign: 'center' }}>Camera</TabelCell>
      <TabelCell style={{ textAlign: 'center' }}>Verify</TabelCell>
      <TabelCell style={{ textAlign: 'center' }}>Info</TabelCell>
      <TabelCell style={{ textAlign: 'center' }}>Label</TabelCell>
    </TabelRow>
  );
};

export default React.memo(SlotTableHeadRow);
